import { formatShortDateWithWeekday, formatTime } from "@clipboard-health/date-time";
import { Stack } from "@mui/material";
import { Text } from "@src/appV2/redesign/system/ui-components";
import { differenceInMinutes, formatDuration } from "date-fns";

interface BookedInterviewCardTitleProps {
  interviewStart: Date;
  interviewEnd: Date;
  workerTimezone: string;
}

export function BookedInterviewCardTitle(props: BookedInterviewCardTitleProps) {
  const { interviewStart, interviewEnd, workerTimezone } = props;

  const interviewDate = formatShortDateWithWeekday(interviewStart, {
    timeZone: workerTimezone,
  });

  const interviewStartTime = formatTime(interviewStart, {
    timeZone: workerTimezone,
  });
  const interviewEndTime = formatTime(interviewEnd, {
    timeZone: workerTimezone,
  });
  const interviewDurationInMinutes = differenceInMinutes(
    new Date(interviewEnd),
    new Date(interviewStart)
  );
  const interviewDurationFormatted = formatDuration(
    { minutes: interviewDurationInMinutes },
    { format: ["hours", "minutes"] }
  ).replace("minutes", "mins");

  return (
    <>
      <Stack direction="row" alignItems="center" spacing={2}>
        <Text semibold variant="h6">
          Interview on {interviewDate}
        </Text>
      </Stack>
      <Stack direction="row" alignItems="end" spacing={3}>
        <Text semibold variant="h6">
          {interviewStartTime} - {interviewEndTime}
        </Text>
        <Text variant="body2" sx={{ color: (theme) => theme.palette.text.tertiary }}>
          {interviewDurationFormatted}
        </Text>
      </Stack>
    </>
  );
}
